function getLocations(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/locations`;
  return apiClient.get(route, { query });
}

export default {
  getLocations
};
